export type HttpClientOpts = {
  baseUrl?: string;
  getToken?: () => string | null;           // opzionale (JWT, ecc.)
  credentials?: RequestCredentials;         // 'include' se usi cookie cross-site
};

export class HttpClient {
  private baseUrl: string;
  private getToken?: () => string | null;
  private credentials: RequestCredentials;

  constructor(opts: HttpClientOpts = {}) {
    this.baseUrl = (opts.baseUrl || "").replace(/\/$/, "");
    this.getToken = opts.getToken;
    this.credentials = opts.credentials ?? "same-origin";
  }

  private async request<T>(
    path: string,
    { method = "GET", body, headers = {}, auth = true, signal }: {
      method?: "GET"|"POST"|"PUT"|"PATCH"|"DELETE";
      body?: unknown;
      headers?: Record<string,string>;
      auth?: boolean;
      signal?: AbortSignal;
    } = {}
  ): Promise<T> {

    const url = `${this.baseUrl}${path}`;

    const init: RequestInit = {
      method,
      headers: { Accept: "application/json", ...headers },
      credentials: this.credentials,
      signal,
    };

    if (auth && this.getToken) {
      const token = this.getToken();
      if (token) (init.headers as any).Authorization = `Bearer ${token}`;
    }
    if (body !== undefined) {
      (init.headers as any)["Content-Type"] = "application/json";
      init.body = JSON.stringify(body);
    }

    const res = await fetch(url, init);
    const text = await res.text();
    let data: any = null;
    try { data = text ? JSON.parse(text) : null; } catch { data = text; }
    if (!res.ok) {
      const err: any = new Error(data?.message || res.statusText || "Request failed");
      err.status = res.status; err.data = data;
      throw err;
    }
    return data as T;
  }

  get   <T>(path: string, options?: any) { return this.request<T>(path, { ...options, method: "GET" }); }
  post  <T>(path: string, body?: unknown, options?: any) { return this.request<T>(path, { ...options, method: "POST", body }); }
  put   <T>(path: string, body?: unknown, options?: any) { return this.request<T>(path, { ...options, method: "PUT",  body }); }
  patch <T>(path: string, body?: unknown, options?: any) { return this.request<T>(path, { ...options, method: "PATCH",body }); }
  delete<T>(path: string, options?: any) { return this.request<T>(path, { ...options, method: "DELETE" }); }
}

// -- ISTANZE PER I TUOI BACKEND --
// export const httpProducts = new HttpClient({
//   baseUrl: (import.meta as any).env?.VITE_API_BASE_PRODUCTS || "",
  // getToken: () => localStorage.getItem("jwt"), // se serve
// });

// export const httpWp = new HttpClient({
//   baseUrl: (import.meta as any).env?.VITE_API_BASE_WP || "",
//   credentials: "include", // es. se devi mandare cookie WP
// });